import { Space, Button, Popconfirm, Tag, Tooltip } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { RiDeleteBin5Line } from "react-icons/ri";
import dayjs from "dayjs";

export const BOOKING_STATUS = ["ยังไม่จองเรือ", "จองเรือแล้ว", "โหลดแล้ว", "ยกเลิก"];

export const FREIGHT_TERMS = ["PREPAID", "COLLECT"];

export const CONTAINER_TYPES = ["20 GP", "40 GP", "40 HQ", "40 RF", "LCL"];

const day = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-");

const statusColor = (v) => {
  switch (v) {
    case "จองเรือแล้ว":
      return "blue";
    case "โหลดแล้ว":
      return "green";
    case "ยกเลิก":
      return "red";
    default:
      return "orange";
  }
};

export const accessColumn = ({ handleView, handleEdit, handleDelete, handleOpenJo }) => [
  {
    title: "สถานะ",
    dataIndex: "booking_status",
    key: "booking_status",
    width: 120,
    align: "center",
    render: (v) => <Tag color={statusColor(v)}>{v || "ยังไม่จองเรือ"}</Tag>,
  },
  {
    title: "CY Date",
    dataIndex: "cy_date",
    key: "cy_date",
    width: 110,
    align: "center",
    sorter: (a, b) => String(a.cy_date || "").localeCompare(String(b.cy_date || "")),
    render: day,
  },
  {
    title: "Load Date",
    dataIndex: "load_date",
    key: "load_date",
    width: 110,
    align: "center",
    sorter: (a, b) => String(a.load_date || "").localeCompare(String(b.load_date || "")),
    render: (v, r) => (
      <Tooltip title={r.load_time ? `เวลาโหลด ${r.load_time}` : ""}>{day(v)}</Tooltip>
    ),
  },
  {
    title: "RT Date",
    dataIndex: "rt_date",
    key: "rt_date",
    width: 110,
    align: "center",
    render: day,
  },
  {
    /* 1 booking อาจมีหลาย Job (เช่น 2 invoice โหลดรวมกัน 1 ตู้) */
    title: "Job No.",
    dataIndex: "jocode_list",
    key: "jocode_list",
    width: 140,
    render: (v, r) => {
      const list = String(v || r.jocode || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean);
      if (list.length === 0) return "-";
      return (
        <Space size={2} wrap>
          {list.map((jo) => (
            <Button
              key={jo}
              type="link"
              size="small"
              style={{ padding: 0 }}
              onClick={() => handleOpenJo(jo)}
            >
              {jo}
            </Button>
          ))}
        </Space>
      );
    },
  },
  {
    title: "INV No.",
    dataIndex: "inv_list",
    key: "inv_list",
    width: 140,
    render: (v, r) => v || r.inv_code || "-",
  },
  { title: "ลูกค้า", dataIndex: "cusname", key: "cusname", width: 180, ellipsis: true },
  { title: "Brand", dataIndex: "brand", key: "brand", width: 130, ellipsis: true },
  { title: "Booking No.", dataIndex: "booking_no", key: "booking_no", width: 140 },
  { title: "ชื่อเรือ", dataIndex: "vessel", key: "vessel", width: 190, ellipsis: true },
  { title: "ETD", dataIndex: "etd", key: "etd", width: 110, align: "center", render: day },
  { title: "ETA", dataIndex: "eta", key: "eta", width: 110, align: "center", render: day },
  {
    title: "จำนวนตู้ (FCL)",
    dataIndex: "fcl",
    key: "fcl",
    width: 120,
    align: "center",
    render: (v, r) =>
      Number(v || 0) > 0 ? `${Number(v)} ${r.container_type || ""}`.trim() : "-",
  },
  { title: "Agent", dataIndex: "agent", key: "agent", width: 160, ellipsis: true },
  { title: "Freight", dataIndex: "freight", key: "freight", width: 100, align: "center" },
  { title: "หัวลาก", dataIndex: "trailer", key: "trailer", width: 130, ellipsis: true },
  {
    title: "ที่ลากตู้ / ที่บรรจุ",
    dataIndex: "pickup_place",
    key: "pickup_place",
    width: 150,
    ellipsis: true,
  },
  { title: "Closing Time", dataIndex: "closing_time", key: "closing_time", width: 130 },
  {
    title: "1st Return",
    dataIndex: "first_return",
    key: "first_return",
    width: 110,
    align: "center",
    render: day,
  },
  { title: "SI Cut off", dataIndex: "si_cutoff", key: "si_cutoff", width: 120 },
  { title: "VGM Cut off", dataIndex: "vgm_cutoff", key: "vgm_cutoff", width: 120 },
  { title: "หมายเหตุ", dataIndex: "remark", key: "remark", width: 180, ellipsis: true },
  {
    title: "Action",
    key: "operation",
    fixed: "right",
    width: 150,
    render: (_, record) => (
      <Space>
        <Tooltip title="ดู Job Order">
          <Button
            size="small"
            icon={<EyeOutlined />}
            className="bn-info-outline"
            disabled={!record.jocode}
            onClick={() => handleOpenJo(record.jocode)}
          />
        </Tooltip>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          size="small"
          icon={<EditOutlined />}
          className="bn-primary-outline"
          onClick={() => handleEdit(record)}
        />
        <Popconfirm
          title="ลบแผนโหลดนี้?"
          okText="ลบ"
          cancelText="ยกเลิก"
          onConfirm={() => handleDelete(record)}
        >
          <Button size="small" danger icon={<RiDeleteBin5Line />} />
        </Popconfirm>
      </Space>
    ),
  },
];
